import { render, staticRenderFns } from "./UsersAgents.vue?vue&type=template&id=0592def9"
import script from "./UsersAgents.vue?vue&type=script&lang=js"
export * from "./UsersAgents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports